<template>
  <div class="page_injuryTables">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <div>
          <!-- <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="94px">
            <el-form-item label="险种名称" size="small">
              <el-input v-model="listQuery.InsuranceName" size="small" clearable></el-input>
            </el-form-item>
          </el-form> -->
        </div>
      </div>
      <div class="top-right">
        <!-- <el-button v-if="showDropScreen == -1" v-preventReClick type="success" size="small" @click="searchHandle" style="margin-right: 15px;">搜索</el-button> -->
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>雇员</el-breadcrumb-item>
          <el-breadcrumb-item>工伤一览表</el-breadcrumb-item>
          <el-breadcrumb-item>工伤平账</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <div class="ftabBtn flex">
          <el-button type="primary" size="small" @click="addNew">&nbsp;新增+</el-button>
        </div>
        <el-table :data="tableData" border class="doc_table" v-loading="loading" style="width:100%">
          <el-table-column prop="Sort" label="序号" width="60" align="center" fixed="left">
            <template slot-scope="scope">
              {{(listQuery.pageNum - 1) * Number(listQuery.pageSize)  + scope.$index + 1}}
            </template>
          </el-table-column>
          <el-table-column prop="r.Idcard" label="身份证号码" width="155" :show-overflow-tooltip="true" align="center" fixed="left">
          </el-table-column>
          <el-table-column prop="r.TimeInjury" label="发生工伤日期" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="rw.InjuredEmployeeName" label="工伤员工姓名" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="rw.ProjectName" label="项目名称" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="rw.BranchOffice" label="分公司" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.FirstBalanceAmount" label="首次平账金额" width="120" :show-overflow-tooltip="true" align="center" fixed="left">
          </el-table-column>
          <el-table-column prop="r.FirstReconciliationTime" label="首次平账时间" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.BalanceBookTwice" label="二次平账金额" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.BalanceBookTwiceTime" label="二次平账时间" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.BalanceAccountThree" label="三次平账金额" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.BalanceAccountThreeTime" label="三次平账时间" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.BalanceFour" label="四次平账金额" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.BalanceFouTime" label="四次平账时间" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.ClosingBalanceAmount" label="终结平账金额" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.ClosingBalanceAmountTime" label="终结平账时间" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.BalanceTotalAmount" label="平账总金额" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.IsBalanceAccountsCompleted" label="是否平账完结" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.ActualAmountEmployees" label="实际赔付员工金额" width="140" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.Remark" label="工伤平账备注" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.IsRiskMoneyAside" label="是否风险金计提" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>

          <el-table-column label="操作" align="center" fixed="right" width="90px">
            <template slot-scope={row}>
              <div class="injuryTabBtn">
                <el-button type="text" @click="edit(row)">编辑</el-button>
                <el-popconfirm title="请确定是否作废？" @confirm="del(row)" style="margin-left: 10px;">
                  <el-button type="text" slot="reference">作废</el-button>
                </el-popconfirm>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <div class="block">
          <el-pagination v-if="totalCount>0" @current-change="currentChange" :current-page.sync="listQuery.pageNum" :page-size="Number(listQuery.pageSize)" @size-change="handleSizeChange" :page-sizes="[10,20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="totalCount"></el-pagination>
        </div>
      </div>
    </div>

    <el-dialog title="新增" :visible.sync="showAdd" width="1050px">
      <div class="formData">
        <el-form :model="formData" :inline="true" ref="formData" :rules="rules" label-width="170px">
          <el-form-item label="身份证号码" prop="Idcard">
            <el-input v-model.trim="formData.Idcard" style="width:300px" size="small" @blur="getIdcardInfo"></el-input>
          </el-form-item>
          <el-form-item label="发生工伤日期" prop="TimeInjury">
            <!-- <el-date-picker type="date" placeholder="" v-model="formData.TimeInjury" value-format="yyyy-MM-dd" style="width:300px" size="small"></el-date-picker> -->
            <el-select v-model="formData.TimeInjury" placeholder="" clearable size="small" style="width:300px" value-key="Id" @change="changeTimeInjury">
              <el-option v-for="(item,index) in injuryDateList" :key="index" :label="item.TimeInjury" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="工伤员工姓名">
            <el-input v-model="name" disabled readonly style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="项目名称">
            <el-input v-model="proName" disabled readonly style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="首次平账金额" prop="FirstBalanceAmount">
            <el-input v-model="formData.FirstBalanceAmount" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="首次平账时间" prop="FirstReconciliationTime">
            <el-date-picker type="date" placeholder="" v-model="formData.FirstReconciliationTime" value-format="yyyy-MM-dd" style="width:300px" size="small"></el-date-picker>
          </el-form-item>
          <el-form-item label="二次平账金额" prop="BalanceBookTwice">
            <el-input v-model="formData.BalanceBookTwice" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="二次平账时间" prop="BalanceBookTwiceTime">
            <el-date-picker type="date" placeholder="" v-model="formData.BalanceBookTwiceTime" value-format="yyyy-MM-dd" style="width:300px" size="small"></el-date-picker>
          </el-form-item>
          <el-form-item label="三次平账金额" prop="BalanceAccountThree">
            <el-input v-model="formData.BalanceAccountThree" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="三次平账时间" prop="BalanceAccountThreeTime">
            <el-date-picker type="date" placeholder="" v-model="formData.BalanceAccountThreeTime" value-format="yyyy-MM-dd" style="width:300px" size="small"></el-date-picker>
          </el-form-item>
          <el-form-item label="四次平账金额" prop="BalanceFour">
            <el-input v-model="formData.BalanceFour" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="四次平账时间" prop="BalanceFouTime">
            <el-date-picker type="date" placeholder="" v-model="formData.BalanceFouTime" value-format="yyyy-MM-dd" style="width:300px" size="small"></el-date-picker>
          </el-form-item>
          <el-form-item label="终结平账金额" prop="ClosingBalanceAmount">
            <el-input v-model="formData.ClosingBalanceAmount" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="终结平账时间" prop="ClosingBalanceAmountTime">
            <el-date-picker type="date" placeholder="" v-model="formData.ClosingBalanceAmountTime" value-format="yyyy-MM-dd" style="width:300px" size="small"></el-date-picker>
          </el-form-item>
          <el-form-item label="平账总金额" prop="BalanceTotalAmount">
            <el-input v-model="formData.BalanceTotalAmount" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="是否平账完结" prop="IsBalanceAccountsCompleted">
            <el-select v-model="formData.IsBalanceAccountsCompleted" placeholder="" clearable size="small" style="width:300px">
              <el-option value="是"></el-option>
              <el-option value="否"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="实际赔付员工金额" prop="ActualAmountEmployees">
            <el-input v-model="formData.ActualAmountEmployees" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="工伤平账备注" prop="Remark">
            <el-input v-model="formData.Remark" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item prop="IsRiskMoneyAside">
            <template #label>
              <span>是否风险金计提
                <el-tooltip placement="top" effect="light">
                  <div slot="content">
                    <div>计提风险金：表示承担风险</div>
                  </div>
                  <i class="el-icon-question cp"></i>
                </el-tooltip>
              </span>
            </template>
            <el-select v-model="formData.IsRiskMoneyAside" placeholder="" clearable size="small" style="width:300px">
              <el-option value="是"></el-option>
              <el-option value="否"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showAdd = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="confirmSubmit">提 交</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  import xz from "../../common";
  import FUN from "../../fun";
  import checkPermission from '@/utils/permission' // 权限判断函数
  import {
    nextTick
  } from 'vue';
  export default {
    data() {
      return {
        listQuery: {
          InsuranceName: '', //险种名称
          ServerName: '', //服务商
          Bntype: '', //商保类别
          pageNum: 1,
          pageSize: 10,
        },
        tableData: [],
        totalCount: 0,
        loading: false,
        showAdd: false,
        formData: {
          Idcard: '', //身份证号码
          TimeInjury: '', //发生工伤时间（年-月-日）
          FirstBalanceAmount: '', //首次平账金额
          FirstReconciliationTime: '', //首次平账时间
          BalanceBookTwice: '', //二次平账金额
          BalanceBookTwiceTime: '', //二次平账时间
          BalanceAccountThree: '', //三次平账金额
          BalanceAccountThreeTime: '', //三次平账金额时间
          BalanceFour: '', //四次平账金额
          BalanceFouTime: '', //四次平账金额时间
          ClosingBalanceAmount: '', //终结平账金额
          ClosingBalanceAmountTime: '', //终结平账时间
          BalanceTotalAmount: '', //平账总金额
          IsBalanceAccountsCompleted: '', //是否平账完结
          ActualAmountEmployees: '', //实际赔付员工金额
          Remark: '', //备注
          IsRiskMoneyAside: '', //是否风险金计提
        },
        rules: {
          Idcard: {
            required: true,
            message: '请输入身份证号码',
            trigger: 'blur'
          },
          TimeInjury: {
            required: true,
            message: '请选择发生工伤日期',
            trigger: 'change'
          },
          FirstBalanceAmount: {
            required: true,
            message: '请输入首次平账金额',
            trigger: 'blur'
          },
          FirstReconciliationTime: {
            required: true,
            message: '请选择首次平账时间',
            trigger: 'change'
          },
          BalanceBookTwice: {
            required: true,
            message: '请输入二次平账金额',
            trigger: 'blur'
          },
          BalanceBookTwiceTime: {
            required: true,
            message: '请选择二次平账时间',
            trigger: 'change'
          },
          BalanceAccountThree: {
            required: true,
            message: '请输入三次平账金额',
            trigger: 'blur'
          },
          BalanceAccountThreeTime: {
            required: true,
            message: '请选择三次平账金额时间',
            trigger: 'change'
          },
          BalanceFour: {
            required: true,
            message: '请输入四次平账金额',
            trigger: 'blur'
          },
          BalanceFouTime: {
            required: true,
            message: '请选择四次平账金额时间',
            trigger: 'change'
          },
          ClosingBalanceAmount: {
            required: true,
            message: '请输入终结平账金额',
            trigger: 'blur'
          },
          ClosingBalanceAmountTime: {
            required: true,
            message: '请选择终结平账时间',
            trigger: 'change'
          },
          BalanceTotalAmount: {
            required: true,
            message: '请输入平账总金额',
            trigger: 'blur'
          },
          IsBalanceAccountsCompleted: {
            required: true,
            message: '请选择是否平账完结',
            trigger: 'change'
          },
          IsBalanceAccountsCompleted: {
            required: true,
            message: '请输入实际赔付员工金额',
            trigger: 'blur'
          },
          ActualAmountEmployees: {
            required: true,
            message: '请输入实际赔付员工金额',
            trigger: 'blur'
          },
          Remark: {
            required: true,
            message: '请输入备注',
            trigger: 'blur'
          },
          IsRiskMoneyAside: {
            required: true,
            message: '请选择是否风险金计提',
            trigger: 'change'
          },
        },
        injuryDateList: [], //工伤日期列表
        name: '',
        proName: '',
        roletype:localStorage.loginRoletype,
      }
    },
    created() {
      this.getWiinsuranceGroupReconc4List();
    },
    methods: {
      checkPermission,
      currentChange(val) {
        this.listQuery.pageNum = Number(val);
        this.getWiinsuranceGroupReconc4List();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.listQuery.pageNum = 1;
        this.listQuery.pageSize = val;
        this.getWiinsuranceGroupReconc4List();
      },
      searchHandle() {
        this.listQuery.pageNum = 1;
        this.getWiinsuranceGroupReconc4List();
      },
      //取【4】保险组-工伤平账列表
      getWiinsuranceGroupReconc4List() {
        this.loading = true;
        xz.getWiinsuranceGroupReconc4List(this.listQuery, this.roletype).then(res => {
          if (res.status == "ok") {
            this.tableData = res.data.data;
            this.totalCount = res.data.totalcount;
            this.loading = false;
          } else {
            this.loading = false;
            this.tableData = [];
          }
        })
      },
      //新增
      addNew() {
        this.clearForm();
        this.showAdd = true;
      },
      edit(item) {
        //取保险组-工伤平账详情
        xz.getWiinsuranceGroupReconc4(item.r.Id, this.roletype).then(res => {
          if (res.status == "ok") {
            this.formData = res.data;
          } else {
            this.formData = item;
          }
          this.showAdd = true;
        })
      },
      //确认新增/修改
      confirmSubmit() {
        this.$refs["formData"].validate((valid) => {
          if (valid) {
            xz.updataWiinsuranceGroupReconc4(this.formData, this.roletype).then(res => {
              if (res.status == "ok") {
                this.showAdd = false;
                this.getWiinsuranceGroupReconc4List();
                this.$message.success('新增成功！')
              } else {
                this.showAdd = false;
                this.$message.error(res.msg)
              }
            })
          }
        })
      },
      //删除【4】保险组-工伤平账详情
      del(item) {
        xz.delWiinsuranceGroupReconc4(item.r.Id, this.roletype).then(res => {
          if (res.status == "ok") {
            this.getWiinsuranceGroupReconc4List();
            this.$message.success('作废成功！')
          } else {
            this.getWiinsuranceGroupReconc4List();
            this.$message.error(res.msg)
          }
        })
      },
      clearForm() {
        this.name = '';
        this.proName = '';
        this.formData = {
          Idcard: '', //身份证号码
          TimeInjury: '', //发生工伤时间（年-月-日）
          FirstBalanceAmount: '', //首次平账金额
          FirstReconciliationTime: '', //首次平账时间
          BalanceBookTwice: '', //二次平账金额
          BalanceBookTwiceTime: '', //二次平账时间
          BalanceAccountThree: '', //三次平账金额
          BalanceAccountThreeTime: '', //三次平账金额时间
          BalanceFour: '', //四次平账金额
          BalanceFouTime: '', //四次平账金额时间
          ClosingBalanceAmount: '', //终结平账金额
          ClosingBalanceAmountTime: '', //终结平账时间
          BalanceTotalAmount: '', //平账总金额
          IsBalanceAccountsCompleted: '', //是否平账完结
          ActualAmountEmployees: '', //实际赔付员工金额
          Remark: '', //备注
          IsRiskMoneyAside: '', //是否风险金计提
        }
      },
      getIdcardInfo() {
        if (this.formData.Idcard.length == 18) {
          let data = {
            pageNum: 1,
            pageSize: 1000,
            Idcard: this.formData.Idcard
          }
          xz.getWIAccidentReportList(data, this.roletype).then(res => {
            if (res.status == "ok") {
              if (res.data.data.length > 0) {
                this.injuryDateList = res.data.data;
              } else {
                this.injuryDateList = [];
                this.$message.error('请先添加工伤事故报告信息')
              }
            } else {
              this.injuryDateList = [];
              this.$message.error('获取身份证信息失败')
            }
          })
        }
      },
      changeTimeInjury(val) {
        this.formData.TimeInjury = val.TimeInjury;
        this.name = val.InjuredEmployeeName;
        this.proName = val.ProjectName;
      }
    }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 0px 16px 16px;
    margin-bottom: 16px;
  }

  .ftabBtn {
    padding: 10px 0;
  }
</style>
<style>
  .page_injuryTables .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_injuryTables .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_injuryTables .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_injuryTables .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_injuryTables .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 10px;
    background: #fff;
  }

  .page_injuryTables .formData .el-form-item {
    margin-bottom: 10px;
  }

  .page_injuryTables .formData .el-form-item__error {
    top: 34px;
  }

  .page_injuryTables .injuryTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_injuryTables .formData .el-icon-question:before {
    color: #F56C6C;
  }
</style>